module.exports = __webpack_public_path__ + "static/media/up_arrow.c27c4373.png";